import createLang from '@/utils/create-lang'

export default (options) => {
	createLang('shop', options)
}
